import { Box, Text, Grid, VStack, Image, Badge } from '@chakra-ui/react';
import { MatchDetails } from './MatchDetails';
import { MatchActions } from './MatchActions';
import { getDocumentUrl } from '../../utils/helpers';
import { MatchCard } from './MatchCard';

interface BestMatchProps {
  match: any;
  submittedFaceUrl: string | null;
  API_URL: string;
  onStatsOpen: () => void;
  setSelectedMatchStats: (match: any) => void;
  isSelectable?: boolean;
  isSelected?: boolean;
  onSelect?: (match: any, selected: boolean) => void;
}

export const BestMatch = ({ 
  match, 
  submittedFaceUrl, 
  API_URL, 
  onStatsOpen, 
  setSelectedMatchStats,
  isSelectable = false,
  isSelected = false,
  onSelect
}: BestMatchProps) => {
  if (!match || match.similarity < 0.57) {
    return (
      <Box w="full" bg="gray.800" p={6} borderRadius="xl">
        <VStack spacing={4} align="center" p={6}>
          <Text fontSize="2xl" fontWeight="bold" color="yellow.500">
            No High Probability Matches Found
          </Text>
          <Text color="gray.400" textAlign="center">
            All matches are below 57% confidence. Please review the lower probability matches below with caution.
          </Text>
        </VStack>
      </Box>
    );
  }

  const filename = match.image_path.split('/').pop();
  const imageUrl = `${API_URL}/api/faces/${filename}`;

  const getSourceBadgeProps = (source: string) => {
    const colorScheme = {
      'fugitive_database': 'red.700',
      'slack_mattermost_export': 'purple.700',
      'satg_suspects': 'orange.700',
      'misc_intel': 'teal.700',
      'oj_bookings': 'green.700',
      'rici_database': 'blue.700',
      'rockland_rici': 'cyan.700'
    }[source] || 'blue.700';

    const label = {
      'rici_database': 'Westchester Bookings',
      'fugitive_database': 'Westchester Fugitive Database',
      'slack_mattermost_export': 'Slack Archive',
      'satg_suspects': 'SATG Suspects',
      'misc_intel': 'Misc Intel Documents',
      'oj_bookings': 'Northern Bookings',
      'rockland_rici': 'Rockland Bookings'
    }[source] || source;

    return { colorScheme, label };
  };

  return (
    <Box w="full">
      <Text fontSize="2xl" fontWeight="bold" color="white" mb={4}>
        Best Match
      </Text>
      <MatchCard
                match={match} 
                submittedFaceUrl={submittedFaceUrl}
                API_URL={API_URL}
        onStatsOpen={onStatsOpen}
        setSelectedMatchStats={setSelectedMatchStats}
        isSelectable={isSelectable}
        isSelected={isSelected}
        onSelect={onSelect}
              />
    </Box>
  );
}; 